import { RootState } from '../../store';

export const getUserNameSelector = (state: RootState) => state?.authReducer?.username;
